import {
  AuthenticatedArea,
  AuthPortal,
  SuiteAccountControls,
  useAccessToken,
} from "@tribunalea/auth/react";
import { useRouter } from "@tribunalea/ui";
import { AppShell } from "./components/AppShell.jsx";
import { StudyPage } from "./pages/StudyPage.jsx";

function LexiaRoutes({ authEnabled, accountControls, getAccessToken }) {
  const { path, navigate } = useRouter();

  if (path !== "/") navigate("/", { replace: true });

  return (
    <AppShell
      authEnabled={authEnabled}
      accountControls={accountControls}
    >
      <StudyPage getAccessToken={getAccessToken} />
    </AppShell>
  );
}

function ClerkApp() {
  const getAccessToken = useAccessToken();
  return (
    <LexiaRoutes
      authEnabled
      accountControls={<SuiteAccountControls />}
      getAccessToken={getAccessToken}
    />
  );
}

function SignInScreen() {
  return (
    <AuthPortal
      productName="LEXIA"
      headline="Entender el derecho empieza por sus fuentes."
      description="Estudiá con Justiniano y recorré normas, jurisprudencia y doctrina sin perder de vista de dónde surge cada explicación."
      proofPoints={[
        "Normas, jurisprudencia y doctrina",
        "Explicaciones con referencias",
        "Una conversación para profundizar",
      ]}
    />
  );
}

export default function App({ authEnabled }) {
  if (authEnabled) {
    return (
      <AuthenticatedArea signedOut={<SignInScreen />}>
        <ClerkApp />
      </AuthenticatedArea>
    );
  }

  return <LexiaRoutes authEnabled={false} getAccessToken={null} />;
}
